import { get, startCase } from "lodash";
import { useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";
import { useUpdateUserPrintTemplates } from "../../../adapters/uplist";
import { useUser } from "../../../context/UserContext";
import { PRINT_OPTIONS } from "../../../helpers/printConstants";
import { Input, Select } from "../../fields";
import { usePrintTypeSkus } from "./helpers";
import { PRINT_MINIMUMS_BY_SKU } from "../../../helpers/constants";

export const PrintPaperSelect = ({ type }) => {
  const {
    size = false,
    weight = false,
    bleed: sku = false,
  } = useWatch({ name: type }) || {};
  const options = PRINT_OPTIONS[type];

  return (
    <Row>
      <Col xs={4}>
        <OptionSelect
          type={type}
          sku="size"
          options={get(options, "sizes", [])}
        />
      </Col>
      <Col xs={4}>
        <OptionSelect
          key={size}
          type={type}
          sku="weight"
          options={get(options, `weights.${size}`, [])}
        />
      </Col>
      <Col xs={4}>
        <OptionSelect
          key={weight}
          type={type}
          sku="bleed"
          options={get(options, `bleeds.${size}.${weight}`, [])}
        />
      </Col>
      {sku && (
        <>
          <Col xs={4}>
            <Input
              sku={sku}
              type="number"
              label={startCase(`${type} Quantity`)}
              minimum={PRINT_MINIMUMS_BY_SKU[sku]}
            />
          </Col>
          <AddTemplateButton sku={sku} type={type} />
        </>
      )}
    </Row>
  );
};

const AddTemplateButton = ({ sku, type }) => {
  const { user } = useUser();
  const skus = usePrintTypeSkus(type);

  const { mutate } = useUpdateUserPrintTemplates();
  if (!user || skus.includes(sku)) return null;

  return (
    <Col xs={"auto"} style={{ display: "flex", alignItems: "flex-end" }}>
      <Button
        onClick={() => {
          mutate({ id: user.id, sku });
        }}
        className="mb-3"
      >
        Premanently Add Size To Agent Templates
      </Button>
    </Col>
  );
};

const OptionSelect = ({ type, sku, options }) => {
  const { setValue, resetField, getValues } = useFormContext();

  const resetFields = (sku) => {
    const skus = [
      `${type}.size`,
      `${type}.weight`,
      `${type}.bleed`,
      getValues(`${type}.bleed`),
    ];
    const sku_index = skus.indexOf(sku);
    skus.filter((s, i) => i > sku_index).forEach(resetField);
  };

  const handleChange = (change, val, sku) => resetFields(sku);

  const label = startCase(type + " " + sku);
  const name = `${type}.${sku}`;

  const default_value = options?.length === 1 && options[0].value;
  useEffect(() => {
    if (default_value) {
      setValue(name, default_value);
    }
  }, [name, default_value, setValue]);
  if (!options.length) return null;
  return (
    <Select
      sku={name}
      options={options}
      label={label}
      isClearable
      onChange={handleChange}
      menuPlacement="top"
    />
  );
};
